import { ReactComponent as CalendarTurnIcon } from './calendar_turn.svg';

export default CalendarTurnIcon;
